import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { portalApi } from "@/lib/portalApi";

const PortalAuthContext = createContext(null);

export function PortalAuthProvider({ children }) {
  const [customer, setCustomer] = useState(null);
  const [loading, setLoading] = useState(true);

  const loadMe = useCallback(async () => {
    try {
      const { data } = await portalApi.get("/portal/auth/me");
      setCustomer(data);
    } catch {
      setCustomer(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (localStorage.getItem("portal_token")) loadMe();
    else setLoading(false);
  }, [loadMe]);

  const login = async (email, password) => {
    const { data } = await portalApi.post("/portal/auth/login", { email, password });
    if (data.access_token) localStorage.setItem("portal_token", data.access_token);
    await loadMe();
    return data;
  };

  // Adopt a session handed back by a non-login endpoint — currently the password
  // reset / activation flow, which signs the user straight in so they don't have to
  // retype the password they just chose.
  const adoptSession = async (data) => {
    if (data?.access_token) localStorage.setItem("portal_token", data.access_token);
    await loadMe();
    return data;
  };

  const logout = async () => {
    try { await portalApi.post("/portal/auth/logout"); } catch { /* ignore */ }
    localStorage.removeItem("portal_token");
    setCustomer(null);
  };

  return (
    <PortalAuthContext.Provider value={{ customer, loading, login, logout, adoptSession, refresh: loadMe }}>
      {children}
    </PortalAuthContext.Provider>
  );
}

export const usePortalAuth = () => useContext(PortalAuthContext);
